import { render, staticRenderFns } from "./companyChange.vue?vue&type=template&id=a3b505f0&scoped=true"
import script from "./companyChange.vue?vue&type=script&lang=js"
export * from "./companyChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b505f0",
  null
  
)

export default component.exports